import { defineMessages } from 'react-intl'

import { intlSelector } from '@app/store/slices/intl'
import { createThunk } from '@app/store/thunk'

import { confirm } from './ui'

export const requireActionApprove = (
  entity: 'requests' | 'direct_announcements' | 'announcements' | 'announcement_responses',
  action: 'accept' | 'decline' | 'cancel'
) => {
  return createThunk((dispatch, getState) => {
    const { formatMessage } = intlSelector(getState())
    return dispatch(
      confirm({
        name: `${CONFIRM_ENTITY[entity]}-${action}-modal`,
        content: formatMessage(messages[action], { entity }),
        closeButtonContent: formatMessage(messages.confirm_button),
      })
    )
  })
}

/**
 * The singular, hyphenated entity each name uses. Written out rather than derived: a `replace` and
 * a `slice` produce a `string`, and the twelve names that come out of this are the whole point.
 */
const CONFIRM_ENTITY = {
  announcement_responses: 'announcement-response',
  announcements: 'announcement',
  direct_announcements: 'direct-announcement',
  requests: 'request',
} as const

const messages = defineMessages({
  accept: { id: "store.actions.requireActionApprove.messages.accept.5e54", defaultMessage: `Вы точно хотите {entity, select,
    direct_announcements {принять}
    other {подтвердить}
  } {entity, select,
    requests { заказ}
    direct_announcements { приглашение}
    announcements { объявление}
    announcement_responses { отклик}
    other {}
  }?` },
  cancel: { id: "store.actions.requireActionApprove.messages.cancel.5e54", defaultMessage: `Вы точно хотите отменить{entity, select,
    requests { заказ}
    direct_announcements { приглашение}
    announcements { объявление}
    announcement_responses { отклик}
    other {}
  }?` },
  decline: { id: "store.actions.requireActionApprove.messages.decline.5e54", defaultMessage: `Вы точно хотите отказаться{entity, select,
    requests { от заказа}
    direct_announcements { от приглашения}
    announcements { от объявления}
    other {}
  }?` },
  confirm_button: { id: "store.actions.requireActionApprove.messages.confirm_button.e0b0", defaultMessage: 'Точно' },
})
